export default __webpack_public_path__ + "static/media/whiteTerraform.e82b858a.svg";